import {
  AUTH_TOKEN,
  AUTH_TOKEN_EVENT,
  SPORTSBOOK_CLOSED_DIALOG,
} from "common/src/helpers/constants";

// Get player authentication token
export const getToken = () => {
  return localStorage.getItem(AUTH_TOKEN) || null;
};

// Set authentication token
export const setToken = (token) => {
  localStorage.setItem(AUTH_TOKEN, token);
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(AUTH_TOKEN_EVENT));
  }
};

// Destroy player session
export const destroySession = () => {
  localStorage.removeItem(AUTH_TOKEN);
  sessionStorage.removeItem(SPORTSBOOK_CLOSED_DIALOG);
};
